import { render, staticRenderFns } from "./g3wButton.vue?vue&type=template&id=3142c716&scoped=true&"
import script from "./g3wButton.vue?vue&type=script&lang=ts&"
export * from "./g3wButton.vue?vue&type=script&lang=ts&"
import style0 from "./g3wButton.vue?vue&type=style&index=0&id=3142c716&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3142c716",
  null
  
)

export default component.exports